import { render } from "./index.vue?vue&type=template&id=53a41892&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=53a41892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a41892"],['__file',"src/components/scWaterMark/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53a41892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53a41892', __exports__)) {
    api.reload('53a41892', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=53a41892&scoped=true", () => {
    api.rerender('53a41892', render)
  })

}


export default __exports__